<template>
	<div id="app">
		<router-view :key="$route.fullPath"></router-view>
	</div>
</template>

<script>
	export default {
		name: 'App'

	}
</script>

<style>
	body {
		margin: 0;
		padding: 0;
	}
	
	#app {
		font-family: 'Avenir', Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		color: #2c3e50;
		background: rgba(240, 240, 240, 0.98);
	}
</style>


// WEBPACK FOOTER //
// src/App.vue